<template>
  <div class="animated fadeIn">
    <div id="accueil-eb">
      <b-card>
      <b-row>
        <b-col md="12">
          <h1 class="display-3">Actualités Prévoyance</h1>
        </b-col>
      </b-row>
      <b-row class="row-stats" v-if="hasRule(rules.CAN_ACCESS_ACTUALITE)">
        <b-col md="12">
          <b-row v-if="itemActualites">
            <ul class="list header" style="list-style:none">
              <li style="margin-bottom:30px" v-for="actualite in itemActualites" :key="actualite.id">
                <h5><a class="list-background clickable-title" @click="actualiteDetails(actualite)">{{ actualite.titre }}</a></h5>
                <i class="fa fa-calendar"></i> {{ formatDate(actualite.date_debut) }}
                <div class="list-item prose">
                  <p v-if="actualite.nature === 'Météo'"><img :src="actualite.meteoImageBase64"></p>
                  <p v-else-if="actualite.resume" v-html="actualite.resume"></p>
                  <p v-else-if="actualite.texte" v-html="actualite.texte.substring(0,450)+'...'"></p>

                  <span v-if="actualite.attachments[0] && actualite.nature !== 'Météo'">
                    <a href="#" @click.prevent="download(actualite.attachments[0])"><i class="fa fa-tag"></i> {{ actualite.attachments[0].libelle }}.{{ actualite.attachments[0].extension }}
                    ({{ formatBytes(actualite.attachments[0].taille) }})</a>
                  </span>

                </div>
                <hr>
              </li>
            </ul>
          </b-row>
          <b-row v-else>
            <p>Aucune actualité n'est présente pour l'instant.</p>
          </b-row>
        </b-col>
      </b-row>
      </b-card>
    </div>
    <b-modal centered size="xl" id="modal-news" ref="modal-news" :title="newsTitle">
      <div class="content-bloc">
        <label for="nature"><b>Nature : </b></label>
        <span id="nature" class="ml-3">{{ newsNature }}</span>
      </div>
      <div class="content-bloc mb-3" v-if="newsNature !== 'Météo'">
        <label for="texte"><b>Actualité : </b></label>
        <div class="block-actu" v-html="newsText"></div>
      </div>
      <div class="content-bloc mb-3" v-if="newsPj && newsNature === 'Météo'">
        <div class="block-actu"><img :src="newsMeteoBase64"></div>
      </div>
      <div class="content-bloc mb-3" v-if="newsPj && newsNature !== 'Météo'">
      <h6>
        <span>
          <a href="#" @click.prevent="download(newsPj)"><i class="fa fa-tag"></i> {{ newsPj.libelle }}.{{ newsPj.extension }}
          ({{ formatBytes(newsPj.taille) }})</a>
        </span>
        </h6>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button v-if="hasRule(rules.CAN_MANAGE_ACTUALITE)" type="button" @click="editNews" size="md" variant="primary" class="float-right ml-2">
            <i class="fa fa-edit"></i> Modifier
          </b-button>
          <b-button
            variant="danger"
            class="float-right"
            @click="$bvModal.hide('modal-news')">
            Fermer
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from '../../utils/auth';
  import {espaceGestionRules as rules, hasRule} from "@/utils/rulesHelper";
  import {downloadFile, guardedFile, isEmpty} from "@/utils/fileHelper"

  export default {
  data() {
    return {
      itemActualites: [],
      hasRule,
      rules,
      newsTitle: '',
      newsText: '',
      newsNature: '',
      newsId: '',
      newsPj: '',
      newsMeteoBase64 : '',
    }
  },
  mounted() {
    this.getActualites()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    getActualites() {
      let self = this
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .get('/espaceGestion/actualites/byProfile')
        .then(response => {
          this.$store.commit("IS_LOADING", false)
          this.itemActualites = response.data.actualites
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Un problème est survenu, merci de contacter l\'administrateur',
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    formatDate(textDate) {
      return textDate !== null ? new Date(textDate).toLocaleDateString('fr-FR') : '-'
    },
    formatBytes(bytes, precision = 2) {
      let units = ['o', 'Ko', 'Mo', 'Go', 'To']

	    let varBytes = Math.max(bytes, 0);
	    let pow = Math.floor((bytes ? Math.log(bytes) : 0) / Math.log(1024))
	    pow = Math.min(pow, units.length - 1)

	    varBytes /= Math.pow(1024, pow)

	    return Math.round(varBytes, precision) + ' ' + units[pow]
	  },
    actualiteDetails(actualite) {
      this.newsTitle = actualite.titre;
      this.newsText = actualite.texte;
      this.newsNature = actualite.nature;
      this.newsId = actualite.id;
      this.newsPj = actualite.attachments[0];
      this.newsMeteoBase64 = actualite.meteoImageBase64;
      this.$refs['modal-news'].show();
      // this.$router.push({path: '/espace-gestion/actualite/details/' + actualiteId});
    },
    editNews() {
      this.$router.push({path: '/espace-gestion/actualite/details/' + this.newsId});
    },
    canDownloadGuardedFile(extension) {
        let valid = true;
        if(_.includes(guardedFile, extension)) {
          valid = hasRule(rules.CAN_DOWNLOAD_GUARDED_FILE);
        }
        return valid;
    },
    download(pj) {
      let ext = pj.extension;
      let name = pj.libelle;
      // console.log('link',link)
      if(this.canDownloadGuardedFile(ext)) {
        this.$axios
          .get("/espaceGestion/actualites/piece-jointe/download/"+pj.id, {responseType: 'blob'})
          .then(response => {
            downloadFile(response, name, ext);
          })
          .catch(() => {
            this.$swal({
              position: "top",
              type: "error",
              title: "Attention !!",
              text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
              showConfirmButton: false,
              timer: 4000
            });
          })
      } else {
        this.$swal({
          position: "top",
          type: "error",
          title: "Attention !!",
          text: "Vous n'avez pas le droit pour télécharger cette pièce jointe",
          showConfirmButton: false,
          timer: 3500
        });
      }
    },
  }
}
</script>
<style>
  .clickable-title {
    color: #1e8eb5 !important;
    cursor: pointer;
    border-bottom: #1e8eb5 !important;
  }
</style>
